// extracted by mini-css-extract-plugin
export default {"productDescription":"y_-z","featuredDescription":"z_-z","description":"A_-z","more":"B_-z","descriptionSku":"C_-z"};